import { render, staticRenderFns } from "./ownerMembers.vue?vue&type=template&id=30bd4fd6&scoped=true"
import script from "./ownerMembers.vue?vue&type=script&lang=js"
export * from "./ownerMembers.vue?vue&type=script&lang=js"
import style0 from "./ownerMembers.vue?vue&type=style&index=0&id=30bd4fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bd4fd6",
  null
  
)

export default component.exports